// T-273 — Costruisce la richiesta di stampa per QZ Tray. Logica PURA (niente
// qz-tray, niente DOM) → testabile in node. Prende il PNG dell'etichetta già
// renderizzata (renderLabelCanvas, 203 DPI) e produce config + data nel formato
// che QZ Tray si aspetta per stampare un'immagine a misura fisica su una
// stampante scelta PER NOME (indipendente dalla predefinita di Windows).

export interface QzPrintRequestInput {
  /** Nome esatto della stampante di sistema (da qz.printers.find()). */
  printerName: string;
  /** Data URL PNG dell'etichetta (1 px = 1 dot @203 DPI). */
  pngDataUrl: string;
  widthMm: number;
  heightMm: number;
  /** DPI della stampante (Mirò = 203). */
  dpi?: number;
  copies?: number;
}

export interface QzPixelData {
  type: 'pixel';
  format: 'image';
  flavor: 'base64';
  data: string;
}

export interface QzPrintRequest {
  printerName: string;
  config: {
    units: 'mm';
    size: { width: number; height: number };
    density: number;
    colorType: 'blackwhite';
    rasterize: boolean;
    scaleContent: boolean;
    copies: number;
  };
  data: QzPixelData[];
}

/** Rimuove il prefisso `data:<mime>;base64,` lasciando solo il base64 grezzo. */
function stripDataUrl(dataUrl: string): string {
  const comma = dataUrl.indexOf(',');
  return dataUrl.startsWith('data:') && comma >= 0 ? dataUrl.slice(comma + 1) : dataUrl;
}

export function buildQzPrintRequest(input: QzPrintRequestInput): QzPrintRequest {
  const dpi = input.dpi && input.dpi > 0 ? input.dpi : 203;
  const copies = Number.isFinite(input.copies) && (input.copies ?? 0) > 0
    ? Math.floor(input.copies as number)
    : 1;
  return {
    printerName: input.printerName,
    config: {
      units: 'mm',
      size: { width: input.widthMm, height: input.heightMm },
      density: dpi,
      colorType: 'blackwhite',
      rasterize: true,
      scaleContent: true,
      copies,
    },
    data: [
      {
        type: 'pixel',
        format: 'image',
        flavor: 'base64',
        data: stripDataUrl(input.pngDataUrl),
      },
    ],
  };
}
